export const EVENT_CATALOG_ORDERS_FEATURE = 'event_catalog_orders';
export const REMOTE_SPEAKERSHIP_FEATURE = 'remote_speakership';
/** Gates stub speaker confidence monitor pairing in flow configuration (no backend player type yet). */
export const SPEAKER_CONFIDENCE_MONITORS_FEATURE = 'speaker_confidence_monitors';
/** Gates stub info display pairing in flow configuration (no backend player type yet). */
export const INFO_DISPLAYS_FEATURE = 'info_displays';
